var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberHelpRoundSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 1.34px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.27px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-6 {\r\n        font-size: 8.82px;\r\n        stroke: 0;\r\n        fill: #000;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MemberHelpRoundSolid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberRoundSolid"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.46 133.68 127.83 133.4 132.11 132.54 136.25 131.14 140.17 129.21 143.81 126.78 147.1 123.89 149.97 120.61 152.41 116.97 154.34 113.05 155.75 108.91 156.59 104.66 156.88 100.26 156.59 95.86 155.75 91.61 154.34 87.47 152.41 83.55 149.97 79.92 147.1 76.63 143.81 73.75 140.17 71.32 136.25 69.39 132.11 67.98 127.83 67.13 123.46 66.84 119.1 67.13 114.81 67.98 110.67 69.39 106.75 71.32 103.12 73.75 99.83 76.63 96.95 79.92 94.52 83.55 92.59 87.47 91.18 91.61 90.34 95.86 90.04 100.26 90.34 104.66 91.18 108.91 92.59 113.05 94.52 116.97 96.95 120.61 99.83 123.89 103.12 126.78 106.75 129.21 110.67 131.14 114.81 132.54 119.1 133.4 123.46 133.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "90.04 100.26 90.34 104.66 91.18 108.91 92.59 113.05 94.52 116.97 96.95 120.61 99.83 123.89 103.12 126.78 106.75 129.21 110.67 131.14 114.81 132.54 119.1 133.4 123.46 133.68 127.83 133.4 132.11 132.54 136.25 131.14 140.17 129.21 143.81 126.78 147.1 123.89 149.97 120.61 152.41 116.97 154.34 113.05 155.75 108.91 156.59 104.66 156.88 100.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "156.88 100.26 156.59 95.86 155.75 91.61 154.34 87.47 152.41 83.55 149.97 79.92 147.1 76.63 143.81 73.75 140.17 71.32 136.25 69.39 132.11 67.98 127.83 67.13 123.46 66.84 119.1 67.13 114.81 67.98 110.67 69.39 106.75 71.32 103.12 73.75 99.83 76.63 96.95 79.92 94.52 83.55 92.59 87.47 91.18 91.61 90.34 95.86 90.04 100.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M424.25,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 123.46,
    y1: 100.26,
    x2: 90.72,
    y2: 93.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "154.39 112.93 156.21 106.94 156.88 100.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "92.54 87.59 90.72 93.58 90.05 99.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.21 106.94 148.24 104.2 147.8 106.35 156.21 106.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "156.21 106.94 148.24 104.2 147.8 106.35 156.21 106.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.72 93.58 98.68 96.33 99.12 94.17 90.72 93.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "90.72 93.58 98.68 96.33 99.12 94.17 90.72 93.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 123.46,
    y1: 100.26,
    x2: 156.21,
    y2: 106.95
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(0.98, 0.2, -0.2, 0.98, 107.07, 92.03)"
  }, "Diameter"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberHelpRoundSolid);
export default __webpack_public_path__ + "static/media/MemberHelpRoundSolid.2b0b521f8e7f6f93165aa34aad117c32.svg";
export { ForwardRef as ReactComponent };